export function getFriendlyPathName(pageCategories, pageCategory) {
  var pathArr = [pageCategory.name || ''];
  var hand = pageCategory;
  while (hand.parent_id != null) {
    hand = pageCategories.find(function (pc) {
      return pc.id === hand.parent_id;
    });
    if (hand) {
      pathArr.push(hand.name);
    }
  }
  return pathArr.reverse().join(' / ');
}